import Vue from "vue";
import { Loading } from "element-ui";
import course from "./course";
import classIn from "./classin";
import meeting from "./meeting";
import pageLive from "./classin/pageLive";
import videoPlay from "./videoplay";
import classfile from "./classfile";
import classSelect from "./classselect";
import store from "../../store";
import { homeApis } from "../../api/index";
// import { isMobile } from "../../util/utils";

const user = {
  path: "user",
  component: resolve => require(["../../pages/user"], resolve),
  children: [
    course,
    classIn,
    meeting,
    pageLive,
    videoPlay,
    classfile,
    classSelect
  ],
  beforeEnter: (to, from, next) => {
    // 移动端设备跳转h5课程表页面
    // if (isMobile()) {
    //   window.location.href = location.origin + "/m/live-class/";
    // }
    let token = Vue.prototype.$cookies.get("token");
    if (token) {
      let loading = Loading.service();
      homeApis
        .basicInfo()
        .then(response => {
          if (response.data) {
            const data = response.data;
            store.dispatch("setUserInfo", data.userInfo || {});
            store.dispatch("setPlatformInfo", data.platformJson || {});
            store.dispatch("setClassInfo", data.classInfo || {});
            store.dispatch("setUserNavBarImg", data.userNavBarImg || "");
          }
        })
        .finally(() => {
          loading.close();
          next();
        });
    } else {
      next({ path: "/" }); //跳转到登录页
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/router/user/index.js